<template>
    <div class="map-page">
        <header class="map-hero">
            <div class="map-hero-content">
                <div class="hero-inner">
                    <h1 class="map-title">Carte de tous les trajets</h1>
                    <p class="map-subtitle">
                        Explorez visuellement tous les trajets disponibles sur la plateforme.
                    </p>
                </div>
            </div>
        </header>

        <main class="map-container">
            <section class="map-content">
                <div class="map-card">
                    <div class="map-wrapper">
                        <l-map ref="map" :zoom="zoom" :center="center" class="leaflet-map">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker
                                v-for="(trip, index) in tripMarkers"
                                :key="trip.name + '-' + index"
                                :lat-lng="trip.position"
                            >
                                <l-popup>
                                    <div class="trip-popup">
                                        <strong>{{ trip.name }}</strong>
                                        <p>{{ trip.description }}</p>
                                    </div>
                                </l-popup>
                            </l-marker>
                        </l-map>
                    </div>
                </div>
            </section>
        </main>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><a href="#">Contact</a></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><a href="#">Plan du site</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>

<style>
.app-container.map,
.app-container.map main,
.app-container.map #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.map .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.map .footer-component {
    display: none !important;
}
</style>

<style scoped>
.map-page {
    background: #f6f9f7;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.map-hero {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #fff;
    padding: 80px 20px 60px;
    text-align: center;
}

.map-hero-content {
    width: min(1600px, 96vw);
    margin: 0 auto;
}

.hero-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
}

.map-title {
    margin: 0;
    font-size: 48px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.5px;
}

.map-subtitle {
    margin: 0;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.6;
}

.map-container {
    width: min(1800px, 98vw);
    margin: 0 auto;
    padding: 48px 20px 28px;
    flex: 1;
}

.map-content {
    background: #fff;
    border: 1px solid #e3ebe5;
    border-radius: 12px;
    padding: 26px;
    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.04);
}

.map-card {
    width: 100%;
}

.map-wrapper {
    height: 600px;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
}

.leaflet-map {
    height: 100%;
    width: 100%;
    z-index: 0;
}

.trip-popup p {
    margin: 6px 0 0;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 2rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .map-hero {
        padding: 50px 20px 40px;
    }

    .map-title {
        font-size: 32px;
    }

    .map-subtitle {
        font-size: 16px;
    }

    .map-container {
        padding: 34px 12px 28px;
    }

    .map-content {
        padding: 16px;
    }

    .map-wrapper {
        height: 480px;
    }

    .footer-section {
        padding: 2rem 1rem 100px;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}

@media (max-width: 480px) {
    .map-title {
        font-size: 26px;
    }

    .map-subtitle {
        font-size: 14px;
    }

    .map-content {
        padding: 12px;
    }

    .map-wrapper {
        height: 420px;
    }
}
</style>

<script>
import router from '../../router';
import bus from '../../services/bus-event.js';
import { LMap, LMarker, LPopup, LTileLayer } from 'vue2-leaflet';

export default {
    name: 'map',
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },
    data() {
        return {
            zoom: 6,
            center: [46.603354, 1.888334],
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            tripMarkers: [
                {
                    name: 'Paris -> Lyon',
                    description: 'Trajet disponible - 3 places',
                    position: [48.8566, 2.3522]
                },
                {
                    name: 'Lille -> Bruxelles',
                    description: 'Trajet disponible - 2 places',
                    position: [50.6292, 3.0573]
                },
                {
                    name: 'Bordeaux -> Toulouse',
                    description: 'Trajet disponible - 4 places',
                    position: [44.8378, -0.5792]
                },
                {
                    name: 'Nice -> Marseille',
                    description: 'Trajet disponible - 1 place',
                    position: [43.7102, 7.262]
                },
                {
                    name: 'Genève -> Lausanne',
                    description: 'Trajet disponible - 2 places',
                    position: [46.2044, 6.1432]
                },
                {
                    name: 'Luxembourg -> Metz',
                    description: 'Trajet disponible - 3 places',
                    position: [49.6116, 6.1319]
                }
            ]
        };
    },
    mounted() {
        bus.on('back-click', this.onBackClick);
    },
    methods: {
        onBackClick() {
            router.back();
        }
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
